
import { DealTypeEnum } from '../components/search-filter/model/deal-type.enum';
import { ProductAttribute } from './attributes.model';
import {ProductAnalytics} from './product-analytics.model';
import { ProductPhoto } from './product-photo.model';
import { ProductTypeEnum } from './product-type.enum';

export interface LocationDTO {
  address: string;
  city: string;
  neighborhood: string;
  uf: string;
  zone?: string;
  number: string;
}

export class ProductCard {
  public readonly imageAlternateText?: string;
  public readonly lat?: number;
  public readonly lng?: number;
  public readonly label?: string;
  public readonly type?: string;
  public readonly price?: string;
  public readonly subPrice?: string;
  public readonly priceFormat?: string;
  public readonly name?: string;
  public readonly street?: string;
  public readonly neighborhood?: string;
  public readonly attributes?: ProductAttribute[];
  public readonly geolocation?: { lat: number; lon: number; };

  public readonly id?: string;
  public readonly sku?: string;
  public readonly condominiumFee?: string;
  public readonly fullMonthlyPrice?: string;
  public readonly location?: string;
  public readonly locationDTO?: LocationDTO;
  public readonly rentalPrice?: string;
  public readonly sellingPrice?: string;
  public readonly divisionTypeName?: string;
  public readonly features?: string[];
  public readonly amenities?: string[];
  public readonly stage?: string;
  public readonly createdat?: string;
  public readonly photo?: ProductPhoto[];
  public readonly fullMonthlyPriceFormat?: string;
  public readonly rentalPriceFormat?: string;
  public readonly sellingPriceFormat?: string;
  public readonly productType?: ProductTypeEnum;
  public readonly dealType?: DealTypeEnum;
  public readonly dealTypes?: DealTypeEnum[];
  public readonly divisionUnitType?: string;
  public readonly analytics?: ProductAnalytics;
  public readonly tagCampaign?: string;
  public readonly tag?: string;

  constructor(
    data: any
  ) {

    this.lat = data.geolocation && data.geolocation.lat;
    this.lng = data.geolocation && (data.geolocation.lon || data.geolocation.lng);
    this.productType = data.product_type ? data.product_type : data.productType;
    this.divisionUnitType = data.division_unit_type ? data.division_unit_type : data.divisionUnitType;
    this.dealTypes = data.deal_types;
    Object.assign(this, data);

  }
}
